import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const navLinks = [{
  href: '/leistungen',
  label: 'Leistungen'
}, {
  href: '/projekte',
  label: 'Projekte'
}, {
  href: '/arbeitsweise',
  label: 'Arbeitsweise'
}, {
  href: '/ueber-uns',
  label: 'Über uns'
}, {
  href: '/kontakt',
  label: 'Kontakt'
}];
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);
  const isActive = (href: string) => location.pathname === href || location.pathname.startsWith(href + '/');
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'top-3 left-4 right-4 mx-auto max-w-6xl rounded-2xl liquid-glass' : 'bg-transparent'}`} data-id="element-58">
        <nav className={`mx-auto ${isScrolled ? 'px-6' : 'max-w-7xl px-6 md:px-8 lg:px-12'}`} data-id="element-59">
          <div className={`flex items-center justify-between ${isScrolled ? 'h-16' : 'h-20'} transition-all duration-500`} data-id="element-60">
            {/* Logo */}
            <Link to="/" className="hover:opacity-70 transition-opacity flex-shrink-0" data-id="element-61">
              <img src="https://cdn.magicpatterns.com/uploads/6u4EUbAFt5ttPtBcdrhHUS/Zeichenflache_4.png" alt="fooble media" className="h-10 w-auto" data-id="element-62" />
            </Link>

            {/* Desktop Navigation */}
            <div className="hidden lg:flex items-center gap-8" data-id="element-63">
              {navLinks.map(link => <div key={link.href} className="relative" data-id="element-64">
                  <Link to={link.href} className={`text-sm font-medium transition-colors py-2 ${isActive(link.href) ? 'text-white' : 'text-white/60 hover:text-white'}`} data-id="element-65">
                    {link.label}
                  </Link>
                  {isActive(link.href) && <motion.div layoutId="nav-indicator" className="absolute -bottom-1 left-0 right-0 h-0.5 bg-[#E8781A] rounded-full shadow-[0_0_8px_rgba(232,120,26,0.5)]" transition={{
                type: 'spring',
                stiffness: 500,
                damping: 30
              }} data-id="element-66" />}
                </div>)}
            </div>

            {/* Desktop CTA */}
            <div className="hidden lg:block" data-id="element-67">
              <Link to="/kontakt" className="inline-flex items-center justify-center px-5 py-2.5 text-white text-sm font-medium rounded-xl liquid-glass-accent hover:brightness-110 transition-all duration-300" data-id="element-68">
                Kontakt
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="lg:hidden p-2 -mr-2 text-white" aria-label={isMobileMenuOpen ? 'Menü schließen' : 'Menü öffnen'} data-id="element-69">
              {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-70" /> : <MenuIcon className="w-6 h-6" data-id="element-71" />}
            </button>
          </div>
        </nav>
      </header>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-72">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        x: '100%'
      }} animate={{
        opacity: 1,
        x: 0
      }} exit={{
        opacity: 0,
        x: '100%'
      }} transition={{
        type: 'tween',
        duration: 0.3
      }} className="fixed inset-0 z-40 lg:hidden" data-id="element-73">
            <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={() => setIsMobileMenuOpen(false)} data-id="element-74" />
            <div className="absolute top-0 right-0 bottom-0 w-full max-w-sm liquid-glass border-l border-white/10" style={{
          borderRadius: 0
        }} data-id="element-75">
              <div className="pt-24 px-6 pb-8 flex flex-col h-full" data-id="element-76">
                <nav className="flex flex-col gap-2" data-id="element-77">
                  {navLinks.map(link => <Link key={link.href} to={link.href} className={`py-3 text-lg font-medium transition-colors ${isActive(link.href) ? 'text-white' : 'text-white/60'}`} data-id="element-78">
                      {link.label}
                    </Link>)}
                </nav>
                <div className="mt-auto pt-8" data-id="element-79">
                  <Link to="/kontakt" className="flex items-center justify-center w-full px-6 py-3 text-white text-base font-medium rounded-xl liquid-glass-accent" data-id="element-80">
                    Projekt starten
                  </Link>
                </div>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}